var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-logo"}},[_c('img',{attrs:{"src":require('@/assets/images/illustrations/error.svg'),"alt":"Oops..."}}),_c('div',{attrs:{"id":"text"}},[_c('div',{attrs:{"id":"primary"}},[_vm._v(_vm._s(_vm.text))]),_c('div',{attrs:{"id":"secondary"}},[_vm._v("Try refreshing this page")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }